export const extractIdFromGid = (gid) => {
  // Split the GID by "/"
  if (!gid) {
    return;
  }
  const parts = gid?.split("/");
  // Get the last part which should be the ID
  const id = parts[parts.length - 1];
  return id;
};

export const divideCategories = (collections) => {
  let parentCategories = [];
  let childCategories = [];
  let thirdChildCategories = [];
  let otherCategories = [];
  const nodes = collections;
  nodes?.forEach((collection) => {
    const string = collection?.title;
    if (string.includes(">")) {
    } else if (string.startsWith("__")) {
      otherCategories.push(collection);
    } else {
      collection.mainId = extractIdFromGid(collection.id);
      parentCategories.push(collection);
    }
  });

  function findParentId(name) {
    let foundCollectionId = null;
    let found = false;
    nodes?.forEach((collection) => {
      if (found) return; // Skip iteration if already found
      const title = collection?.title;
      if (title === name) {
        collection.haveChild = true;
        foundCollectionId = collection.mainId;
        found = true; // Set the flag to true to break out of loop
      }
    });
    return foundCollectionId;
  }

  // Second pass: handle child and third level
  // nodes?.forEach((collection) => {
  //   const string = collection?.title;
  //   if (string.includes(">")) {
  //     const [parent, child] = string.split(" > ");
  //     if (child) {
  //       collection.subTitle = child.trim();
  //       collection.mainId = extractIdFromGid(collection?.id);
  //       collection.parentTitle = parent.trim();
  //       collection.parentMainId = findParentId(parent.trim());
  //       collection.parentGID = childCategories.push(collection);
  //     }
  //   }
  // });

  // Second pass: handle sub child
  nodes?.forEach((collection) => {
    const title = collection?.title;
    const parts = title.split(" > ").map((p) => p.trim());

    if (parts.length === 2) {
      // Parent > Child
      const [parent, child] = parts;
      collection.subTitle = child;
      collection.mainId = extractIdFromGid(collection?.id);
      collection.parentTitle = parent;
      collection.parentMainId = findParentId(parent);
      childCategories.push(collection);
    }
  });

  // Third pass: handle thrid level
  nodes?.forEach((collection) => {
    const title = collection?.title;
    const parts = title.split(" > ").map((p) => p.trim());
    if (parts.length === 3) {
      // Parent > Child > SubChild
      const [parent, child, subChild] = parts;
      collection.subTitle = subChild;
      collection.subParentTitle = `${parent} > ${child}`; // Immediate sub parent title example SWITCHES > 16 AMP ROCKER
      collection.mainId = extractIdFromGid(collection?.id);
      collection.parentTitle = child; // immediate parent is child which is sub category title
      collection.rootTitle = parent; // top-level parent
      collection.parentMainId = findParentId(collection.subParentTitle);
      collection.rootMainId = findParentId(parent);
      thirdChildCategories.push(collection);
    }
  });
  return {
    parentCategories,
    childCategories,
    thirdChildCategories,
    otherCategories,
  };
};

export const checkIfSubCategoryHaveMoreChidCategory = (
  selectedCategory,
  nLevelSubCategories
) => {
  let findCategory;
  let found = false;
  nLevelSubCategories.forEach((val) => {
    if (found) return; // Skip iteration if already found
    if (val.subParentTitle === selectedCategory.title) {
      findCategory = val;
      found = true;
    }
  });
  return findCategory;
};
